import { Trans } from 'react-i18next';

export const RefillAutomationReadOnly = () => {
  return <Trans>Refill to balance limit</Trans>;
};
